import { Svg, Path } from "@react-pdf/renderer";

// Renders the Variant circular V symbol as vector — paths from variant_logo_symbol_circle_line_black.svg (viewBox 0 0 91 90)
const VariantLogoSymbol = ({ size = 28, color = "#111111" }) => (
    <Svg viewBox="0 0 91 90" width={size} height={size}>
        <Path
            d="M21.6 23L38.4896 68.6147H38.4921C39.5027 71.3457 42.118 73.1614 45.0414 73.1614C47.9598 73.1614 50.5702 71.3555 51.5857 68.6319L68.611 23H58.5467L45.0685 61.0278L31.5213 23H21.6Z"
            fill={color}
        />
        <Path
            fillRule="evenodd"
            d="M90.2 44.8C90.2 69.5424 70.1423 89.6 45.4 89.6C20.6576 89.6 0.599976 69.5424 0.599976 44.8C0.599976 20.0576 20.6576 0 45.4 0C70.1423 0 90.2 20.0576 90.2 44.8ZM87.07 44.8C87.07 67.8137 68.4137 86.47 45.4 86.47C22.3863 86.47 3.72998 67.8137 3.72998 44.8C3.72998 21.7863 22.3863 3.13 45.4 3.13C68.4137 3.13 87.07 21.7863 87.07 44.8Z"
            fill={color}
        />
    </Svg>
);

export default VariantLogoSymbol;
